export const getSeparatorClassName = (key: string): string => {
  if (key === '/') return 'text-text-disabled';
  return 'mr-1 text-text-secondary';
};
